import React from 'react'
import SwitchM from '@material-ui/core/Switch'
import classes from './styles.module.scss'
import { withStyles } from '@material-ui/core'
import { getColorButtonPrimary50, getColorButtonSecondary50 } from '../../globalStylesHelper'

interface Props {
  useSecondaryColor?: boolean
  label?: string
  checked: boolean
  onChange: (a: any) => void
  style?: any
}

const colorButtonPrimary50 = getColorButtonPrimary50()
const colorButtonSecondary50 = getColorButtonSecondary50()

export const PrimaryColorSwitch = withStyles(theme => ({
  switchBase: {
    '&$checked': {
      transform: 'translateX(16px)',
      color: 'var(--color-button-primary)',
      '&$checked + $bar': {
        backgroundColor: `${colorButtonPrimary50}`,
        opacity: 1,
        border: 'none',
      },
    },
  },
  checked: {},
  bar: {},
}))(SwitchM)

export const SecondaryColorSwitch = withStyles(theme => ({
  switchBase: {
    '&$checked': {
      transform: 'translateX(16px)',
      color: 'var(--color-button-secondary)',
      '&$checked + $bar': {
        backgroundColor: `${colorButtonSecondary50}`,
        opacity: 1,
        border: 'none',
      },
    },
  },
  checked: {},
  bar: {},
}))(SwitchM)

interface AssistantSwitchProps {
  checked: boolean
  onChange: (event: React.MouseEvent<HTMLButtonElement>) => void
  ariaLabel?: string
  className?: string
  disabled?: boolean
}

/**
 * Larger, fully-rounded pill switch — QCS-themed (success green on, a neutral
 * grey track off) rather than the compact PrimaryColorSwitch above, for
 * surfaces where the toggle is the whole point of its own column rather than
 * a small control next to other content. A plain button rather than the
 * uiKit Switch's `@material-ui/core` Switch — see styles.module.scss for why.
 */
export const AssistantColorSwitch: React.FC<AssistantSwitchProps> = ({
  checked,
  onChange,
  ariaLabel,
  className,
  disabled,
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={onChange}
    className={`${classes.assistantTrack} ${checked ? classes.assistantTrackOn : ''} ${className || ''}`}>
    <span className={classes.assistantThumb} />
  </button>
)

const Switch: React.FC<Props> = ({ label, checked, onChange, useSecondaryColor, style = {} }) => {
  return (
    <div className={classes.container} style={style}>
      {useSecondaryColor ? (
        <SecondaryColorSwitch checked={checked} onChange={onChange} />
      ) : (
        <PrimaryColorSwitch checked={checked} onChange={onChange} />
      )}
      {label && <p className={classes.inputTitle}>{label}</p>}
    </div>
  )
}

export default Switch
